import {combineReducers} from '@reduxjs/toolkit';

import app from '~/store/reducers/AppReducer';
import org_helper from '~/store/reducers/OrgReducer';
import user from '~/store/reducers/UserHelperReducer';
import teams_helper from '~/store/reducers/TeamsHelperReducer';
import notifications from '~/store/reducers/NotificationsReducer';
import dashboard from '~/store/reducers/DashboardReducer';
import feed_helper from '~/store/reducers/FeedHelperReducer';
import forms from '~/store/reducers/FormsReducer';
import members_filter from '~/store/reducers/MembersFilterReducer';
import incidents from '~/store/reducers/IncidentsReducer';
import library from '~/store/reducers/LibraryReducer';
import checkInOptions from '~/store/slices/checkInOptions';
import manageDesks from '~/store/slices/manageDesks';
import manageCheckInAlerts from '~/store/slices/manageCheckInAlerts';
import manageSpaces from '~/store/slices/manageSpaces';

const reducers = combineReducers({
    app, org_helper, user, teams_helper,
    dashboard, feed_helper, forms, library, incidents,
    notifications, members_filter, checkInOptions,
    manageDesks, manageCheckInAlerts, manageSpaces
});

export default reducers;